import { IQueryContext } from 'framework/context/IQueryContext';
import { IInvoiceForwardingQueryParams, IInvoiceForwardingRecord, IQueryResult } from 'gen/ApiClient';
import React from 'react';

export const InvoiceForwardingRecordsQueryContext = React.createContext<IQueryContext<IQueryResult<IInvoiceForwardingRecord>, IInvoiceForwardingQueryParams>>(
	undefined as any
);
